export default __webpack_public_path__ + "static/media/5.84dde336.png";